
export const addGroupAction = function (item) {
    return {
        type: "FB_ADD_GROUP",
        payload: item
    }
};

export const setGroupsAction = function (items) {
    return {
        type: "FB_SET_GROUPS",
        payload: items
    }
};

export const removeGroupAction = function (item) {
    return {
        type: "FB_REMOVE_GROUP",
        payload: item
    }
};

export const clearGroupsAction = function () {
    return {
        type: "FB_CLEAR_GROUPS"
    }
};

export const changeGroupAction = function (item) {
    return {
        type: "FB_CHANGE_GROUP",
        payload: item
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/groups.js